import React from 'react';

function ShortTextQuestion({ question, value = '', onChange, disabled = false }) {
  return (
    <div className="relative">
      <textarea
        name={`question-${question.id}`}
        placeholder={question.placeholder || "Enter your answer..."}
        maxLength={question.maxLength}
        rows={3}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className={`w-full mt-2 p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 shadow-sm resize-y transition-all duration-200 ${
          disabled ? 'bg-gray-100 text-gray-500 cursor-not-allowed' : 'bg-white hover:border-blue-300'
        }`}
      />
      {question.maxLength && (
        <div className="text-right mt-1 text-sm text-gray-500">
          {value.length} / {question.maxLength} characters
        </div>
      )}
    </div>
  );
}

export default ShortTextQuestion;
